import { motion } from "framer-motion";

export const FadeUp = ({ children, delay = 0, className = "", ...rest }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y: 48 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.9, delay, ease: [0.22, 1, 0.36, 1] }}
    {...rest}
  >
    {children}
  </motion.div>
);

export const MaskedLines = ({ lines, className = "", lineClassName = "", delay = 0 }) => (
  <div className={className}>
    {lines.map((line, i) => (
      <span className="mask-line" key={i}>
        <motion.span
          className={`block ${lineClassName}`}
          initial={{ y: "110%" }}
          animate={{ y: 0 }}
          transition={{ duration: 1, delay: delay + i * 0.12, ease: [0.22, 1, 0.36, 1] }}
        >
          {line}
        </motion.span>
      </span>
    ))}
  </div>
);

export const ChapterHeading = ({ num, title, className = "" }) => (
  <FadeUp className={`flex items-baseline gap-4 ${className}`}>
    <span className="font-display text-sm tracking-[0.35em] text-red-500">{num}</span>
    <span className="h-px flex-1 bg-current opacity-15" />
    <span className="text-xs uppercase tracking-[0.3em] opacity-60">{title}</span>
  </FadeUp>
);
